import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Api_Paginated, T_Api_Success_Res } from "./api.types";
import { useMutation } from "@tanstack/react-query";

export const pandaDocService = {
  useGetPandaDocFunctions: () => {
    return useQuery({
      queryKey: ["/pandadoc/functions"],
      queryFn: async () => {
        const res = await api.get(`/pandadoc/functions`);
        return res.data as T_Api_Success_Res<string[]>;
      },
    });
  },

  useGetPandaDocTemplateKeys: (templateId: string | undefined, org_code: string | null) => {
    return useQuery({
      queryKey: ["/pandadoc/template-keys", templateId],
      queryFn: async () => {
        const res = await api.get(`/pandadoc/template-keys/${templateId}?org_code=${org_code}`);
        return res.data as T_Api_Success_Res<{
          tokens: string[];
          existing_map: Record<
            string,
            {
              fn: string;
              type: "value" | "image";
            }
          >;
          signature_fields: any;
        }>;
      },
      enabled: !!templateId && !!org_code,
    });
  },

  useGetOrgMappings: (org_code: string | null) => {
    return useQuery({
      queryKey: ["/pandadoc/saved-mappings", org_code],
      queryFn: async () => {
        const res = await api.get(`/pandadoc/mappings/${org_code}`);
        return res.data as T_Api_Success_Res<
          {
            title: string;
            templateId: string;
            map: Record<string, { fn: string; type: string }>;
          }[]
        >;
      },
      enabled: !!org_code,
    });
  },

  useCreateMappings: () => {
    return useMutation({
      mutationKey: ["/pandadoc/create-mappings"],
      mutationFn: async (body: {
        // appkey: string;
        title: string;
        org_code: string;
        templateId: string;
        map: Record<string, { fn: string; type: "image" | "value" }>;
        signature_fields?: any;
      }) => {
        const res = await api.post(`/pandadoc/mappings`, body);
        return res.data as T_Api_Success_Res<Record<string, any>>;
      },
    });
  },
};
